import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { SCIENTIFIC_SKILLS, COMMERCIAL_SKILLS, MOTIVATIONS } from "@/data/aspiringData";

export function ProfileTab({ profile, update }) {
  const skills = profile.preferred_role === "scientific" ? SCIENTIFIC_SKILLS : 
                 profile.preferred_role === "commercial" ? COMMERCIAL_SKILLS : 
                 [...SCIENTIFIC_SKILLS, ...COMMERCIAL_SKILLS];
  
  const toggleSkill = (s) => {
    const arr = profile.skills || [];
    update("skills", arr.includes(s) ? arr.filter(x => x !== s) : [...arr, s]);
  };
  
  const toggleMotivation = (m) => {
    const arr = profile.motivations || [];
    update("motivations", arr.includes(m) ? arr.filter(x => x !== m) : [...arr, m]);
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Your Profile</h2>
      <Card><CardContent className="p-4 space-y-4">
        <div>
          <Label>LinkedIn URL</Label>
          <Input value={profile.linkedin_url || ""} onChange={e => update("linkedin_url", e.target.value)} placeholder="https://linkedin.com/in/..." />
        </div>
        <div>
          <Label>Preferred Role</Label>
          <RadioGroup value={profile.preferred_role || ""} onValueChange={v => { update("preferred_role", v); update("skills", []); }} className="flex gap-4 mt-2">
            <div className="flex items-center gap-2"><RadioGroupItem value="scientific" id="sci" /><Label htmlFor="sci">Scientific</Label></div>
            <div className="flex items-center gap-2"><RadioGroupItem value="commercial" id="com" /><Label htmlFor="com">Commercial</Label></div>
            <div className="flex items-center gap-2"><RadioGroupItem value="either" id="eith" /><Label htmlFor="eith">Either</Label></div>
          </RadioGroup>
        </div>
        {profile.preferred_role && (
          <div>
            <Label>Skills</Label>
            <div className="grid grid-cols-2 gap-2 mt-2">
              {skills.map(s => (
                <div key={s} className="flex items-center gap-2 p-2 border rounded cursor-pointer" onClick={() => toggleSkill(s)}>
                  <Checkbox checked={profile.skills?.includes(s)} /><span className="text-sm">{s}</span>
                </div>
              ))}
            </div>
          </div>
        )}
        <div>
          <Label>Motivations</Label>
          <div className="grid grid-cols-2 gap-2 mt-2">
            {MOTIVATIONS.map(m => (
              <div key={m.id} className="flex items-center gap-2 p-2 border rounded cursor-pointer" onClick={() => toggleMotivation(m.id)}>
                <Checkbox checked={profile.motivations?.includes(m.id)} /><span className="text-sm">{m.label}</span>
              </div>
            ))}
          </div>
        </div>
        <div>
          <Label>Your Edge</Label>
          <Textarea value={profile.your_edge || ""} onChange={e => update("your_edge", e.target.value)} placeholder="What makes you unique?" rows={3} />
        </div>
      </CardContent></Card>
    </div>
  );
}
